import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NavItem = styled(Link)`
    border-radius: 8px;
    text-align: center;
    font-size: 15px;
    padding: 15px;
    width: 200px;
    color:inherit;
    display:inline;
    text-decoration: none;
    cursor:pointer;
    &:hover{
        text-decoration:none;
        color:inherit;
    }
`

export const VerticalNavBar = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    margin-right: 5%;
    margin-left: 5%;
`

export const Container = styled.div`
    display:flex;
    flex-direction:row;
    margin-right:10%;

    @media (max-width: 900px) {
        flex-direction:column;
        align-items:center;
    }  
`